{
  "name": "@alluzo/web",
  "version": "0.0.0",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "bun run theme:check && tsc -b && vite build",
    "preview": "vite preview",
    "typecheck": "tsr generate && tsc -b --noEmit",
    "theme": "bun scripts/build-theme.ts",
    "theme:check": "bun scripts/build-theme.ts --check",
    "test": "bun test src scripts",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:report": "playwright show-report",
    "lint": "eslint .",
    "routes": "tsr generate"
  },
  "dependencies": {
    "@ai-sdk/react": "4.0.136",
    "@alluzo/shared": "workspace:*",
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/sortable": "^10.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "@microsoft/clarity": "1.0.2",
    "@sentry/react": "^11.4.0",
    "@sqlite.org/sqlite-wasm": "3.53.4-build1",
    "@tanstack/react-router": "^1.170.39",
    "ai": "7.0.133",
    "better-auth": "^1.7.1",
    "canvaskit-wasm": "0.42.0",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "cmdk": "^1.1.1",
    "drizzle-orm": "^0.45.2",
    "elkjs": "0.12.0",
    "i18next": "^26.4.2",
    "lucide-react": "1.42.0",
    "radix-ui": "^1.6.7",
    "react": "19.2.3",
    "react-day-picker": "^10.0.1",
    "react-dom": "19.2.3",
    "sonner": "^2.0.8",
    "tailwind-merge": "^3.7.0",
    "uqr": "0.1.3",
    "zod": "^4.5.4",
    "zustand": "^5.0.15"
  },
  "devDependencies": {
    "@babel/core": "^7.29.0",
    "@eslint/js": "^9.39.5",
    "@playwright/test": "1.63.0",
    "@rolldown/plugin-babel": "0.2.4",
    "@sentry/vite-plugin": "^5.4.0",
    "@tailwindcss/vite": "^4.3.3",
    "@tanstack/router-cli": "^1.167.38",
    "@tanstack/router-plugin": "^1.168.40",
    "@types/bun": "^1.4.0",
    "@types/node": "^22.10.5",
    "@types/react": "~19.2.2",
    "@types/react-dom": "~19.2.3",
    "@vitejs/plugin-react": "^6.1.1",
    "babel-plugin-react-compiler": "1.0.0",
    "eslint": "^9.39.5",
    "eslint-plugin-react-hooks": "^7.1.1",
    "globals": "^17.12.0",
    "tailwindcss": "^4.3.3",
    "tw-animate-css": "^1.4.0",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.70.1",
    "vite": "^8.3.1"
  }
}
